<template>
    <div style="margin-bottom: 140px">
        <div style="margin-bottom: 14px;">
      <div class="page-title">
       Співпраця
      </div>
      <div style="
    margin-top: 34px;
    font-size: 0.9rem;
    text-align: left;
">

<p><strong>Black Pizza</strong><span style="font-weight: 400;"> &ndash; ексклюзивна піцерія міста Луцька з фірмовою піцою на темному тісті. М</span><span style="font-weight: 400;">и працюємо лише на доставку та самовиніс, тому можемо забезпечувати надзвичайно високу якість продукції при значно менших адміністративних витратах у порівнянні із закладами &ldquo;класичного типу&rdquo;.</span></p>
<p><span style="font-weight: 400;">Ми впевнені, що піца &ndash; це універсальний продукт, тому зосереджуємо нашу увагу лише на ній. Ми регулярно вдосконалюємо та оновлюємо власне меню і наразі можемо порадувати наших клієнтів більш, ніж 30+ різновидами піци.</span></p>
<p><span style="font-weight: 400;">Ми відмовились від концепції &ldquo;шаблонної італійської піцерії&rdquo;, натомість створили власний унікальний продукт, який поєднаний із найсучаснішими технологіями.&nbsp;</span></p>
<h3><strong>Коротко про нас:</strong></h3>
<ul>
<li style="font-weight: 400;"><span style="font-weight: 400;">46k+ приготованих піц</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">понад 22k+ замовлень</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">9k+ задоволених клієнтів</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">8-місячна окупність бізнесу</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">високий коефіцієнт самовиносів &ndash; 35%</span></li>
</ul>
<h3><strong>Наші переваги:</strong></h3>
<ol>
<li style="font-weight: 400;"><span style="font-weight: 400;">Юридично захищений бренд</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Власна CRM-система</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Сучасний та зручний веб-сайт та мобільний додаток</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Висока лояльність клієнтів</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Гарантований місячний дохід &ndash; від $3000</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Відсутність зайвого пафосу та незрозумілих термінів</span></li>
</ol>
<p><strong>Маєш</strong><span style="font-weight: 400;"> 15000 доларів стартових інвестицій та бажаєш </span><strong>долучитися</strong><span style="font-weight: 400;"> до команди професіоналів та відкрити власний заклад?</span><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Пиши </span><a href="mailto:our.pizza.black@gmail.com"><span style="font-weight: 400;">our.pizza.black@gmail.com</span></a><span style="font-weight: 400;"> або телефонуй: 093 90 52 303</span></p>
      </div>
    </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

    methods: {
        
    },

    mounted() {

    }
}
</script>
